import { Dialog } from "./Dialog";
import { Tenant, TenantPicker } from "./TenantPicker";

type TenantPickerDialogProps = {
  open: boolean;
  onClose: () => void;
  onTenantSelected: (tenant: Tenant) => void;
  title?: string;
};

export function TenantPickerDialog({
  open,
  onClose,
  onTenantSelected,
  title = "Change Organizations",
}: TenantPickerDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" title={title} noPrimaryAction>
      <TenantPicker onTenantSelected={onTenantSelected} />
    </Dialog>
  );
}
